import { environment } from "../environment";
import { PayloadComment, Comment   } from "../models/comment";
import { AsyncResult } from "../models/common/async-result";
import { Like } from "../models/like";
import api from "./api";

export async function addComment(payload: PayloadComment & Comment): Promise<AsyncResult<Comment>> {
  let baseUrl = environment.api.comment.create;
  
  return await api.post(baseUrl, payload)
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}

export async function getCommentsByBook(userId: number, bookId: number): Promise<Comment[]> {
  let baseUrl = environment.api.comment.getByBook;

  return await api.post(baseUrl, {userId: userId, bookId: bookId})
    .then(res => res.data.success);
}

export async function likeComment(commentId: number, bookId: number, userId: number): Promise<AsyncResult<Like>> {
  let baseUrl = environment.api.like.create;
  
  return await api.post(baseUrl, {
    commentId: commentId, 
    bookId: bookId,
    userId: userId
  })
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}

export async function deslikeComment(commentId: number, bookId: number, userId: number): Promise<AsyncResult<Like>> {
  let baseUrl = environment.api.like.deslike;
  
  return await api.post(baseUrl, {
    commentId: commentId, 
    bookId: bookId,
    userId: userId
  })
    .then(res => { return { success: res.data.success, error: void 0 } })
    .catch(error => { return { success: void 0, error: error.response.data.error } });
}
